var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("地址：中国·安徽·淮南")]),_c('div',[_vm._v("版权所有：淮南矿业集团员工保障服务中心 未经许可禁止非法拷贝或镜像")]),_c('div',[_vm._v("主办：淮南矿业集团员工保障服务中心")])])
}]

export { render, staticRenderFns }